export const COST_VIEWS = [
  { value: "portfolio", label: "Spend", icon: "dashboard" },
  { value: "efficiency", label: "Efficiency", icon: "trend-up" },
  { value: "savings", label: "Savings", icon: "trend-down" },
] as const;

export type Layer = (typeof COST_VIEWS)[number]["value"];

export function isLayer(value: string | undefined): value is Layer {
  return COST_VIEWS.some((view) => view.value === value);
}

export const COST_BREAKDOWNS: Record<string, string> = {
  spenders: "user",
  agents: "kind",
  models: "model",
  customers: "tenant",
};

export function viewOf(value: string): Layer {
  if (value === "unit" || value === "drivers") return "efficiency";
  return isLayer(value) ? value : "portfolio";
}
